import { AuthUserDto, SessionDto } from '../api/models';

export type IRefresherToken = {
  iat: number;
  exp: number;
  sub: string;
  iss: string;
  type: 'refresher';
  email: string;
};
export type JwtPayload = {
  iat: number;
  exp: number;
  sub: string;
  iss: 'AH-APP';
  role: AuthUserDto['role'];
  email: string;
  name: string;
  /** Present when this session is a superadmin impersonating another user; value is the superadmin's uuid. */
  impersonatedBy?: string;
};

export class SessionDtoExtended implements SessionDto {
  accessToken: string;
  accessTokenParsed: JwtPayload;
  refreshToken: string;
  refreshTokenParsed: IRefresherToken;

  constructor(session: SessionDto) {
    this.accessToken = session.accessToken;
    this.refreshToken = session.refreshToken;

    // Fill in the parsed tokens
    this.accessTokenParsed = JSON.parse(atob(this.accessToken.split('.')[1]));
    this.refreshTokenParsed = JSON.parse(atob(this.refreshToken.split('.')[1]));
  }
}
